export enum eGameSort {
  Default = 'default',
  NameAlphabet = 'nameAlphabet',
  NameAlphabetRevers = 'nameAlphabetRevers',
  New = 'new',
}

export type TSortFiltersByPage = Record<
  string,
  {
    sort: eGameSort;
    filters: string[];
  }
>;
